import { useEffect, useRef } from 'react';

const listeners = new Map<string, Set<() => void>>();

/** Tell one visible owner route that it was shown again. Hidden tabs are not notified. */
export function notifyRouteShown(path: string): void {
  const set = listeners.get(path);
  if (!set) return;
  for (const listener of set) listener();
}

export function subscribeRouteShown(path: string, listener: () => void): () => void {
  const set = listeners.get(path) ?? new Set<() => void>();
  set.add(listener);
  listeners.set(path, set);
  return () => {
    set.delete(listener);
    if (!set.size) listeners.delete(path);
  };
}

export function useRevalidateOnShow(path: string, reload: () => void): void {
  const reloadRef = useRef(reload);
  useEffect(() => {
    reloadRef.current = reload;
  });
  useEffect(() => subscribeRouteShown(path, () => reloadRef.current()), [path]);
}
